
// export const myGetter = ( input ) => {
//  return input
// }

export const inputsPaginatedData = state => state.inputsPaginatedData
export const input = state => state.input
export const isLoading = state => state.isLoading
export const inputsUnplacedData = state => state.inputsUnplacedData
export const isLoadingInputsUnplaceData = state => state.isLoadingInputsUnplaceData